import React from 'react';
import Header from './header';
import Footer from './footer';
import './projects.css';

const mark15 = () => {
  return (
    <div>
      <Header />
      <div class='projects-container'>
        <h1 className='title-heading'>
          check out <span class='title-heading-inverted'>my projects </span>
        </h1>

        <ul class='projects-list-non-bullet'>
          <li>
            <div class='ow-list'>
              <h1>
                Component Library -<span class='mark'> Level-1 </span>
              </h1>
              <p>A Simple HTML/CSS Component Library.</p>

              <a
                class='link link-primary'
                href='https://nyaa-ui.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/nyaa-ui'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>
          <li>
            <div class='w-list'>
              <h1>
                2 Blogs - <span class='mark'>M15</span>
              </h1>
              <a
                class='link link-primary'
                href='https://way2nizam.hashnode.dev/how-to-get-started-with-react-router'
                target='_blank'
                rel='noreferrer'>
                Blog 1
              </a>
              <a
                class='link link-secondary'
                href='https://way2nizam.hashnode.dev/react-usestate-hook'
                target='_blank'
                rel='noreferrer'>
                Blog 2
              </a>
            </div>
          </li>
          <li>
            <div class='ow-list'>
              <h1>
                Stocks Profit and Loss - <span class='mark'>M14</span>
              </h1>
              <small>August, 2021</small>
              <p>
                Check your stocks profit & loss. Created app using
                <strong> Vanilla - JS</strong> hosted on
                <strong> Netlify.</strong>
              </p>

              <a
                class='link link-primary'
                href='https://stocks-profit-loss-cal.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/stock-profit-loss'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='w-list'>
              <h1>
                B'day Palindrome checker - <span class='mark'>M13</span>
              </h1>
              <small>August, 2021</small>
              <p>
                Check your birthdate is palindrome or not. Created app using
                <strong> Vanilla - JS</strong> hosted on
                <strong> Netlify.</strong>
              </p>
              <a
                class='link link-primary'
                href='https://palindrome-birthday24x7.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/palindrome-birthday'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='ow-list'>
              <h1>
                Fun with Triangle -<span class='mark'>M12</span>
              </h1>
              <small>August, 2021</small>
              <p>
                Explore Triangle Gyan. Created app using
                <strong> Vanilla - JS</strong> hosted on
                <strong> Netlify.</strong>
              </p>
              <a
                class='link link-primary'
                href='https://triangle-gyan.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/triangles-quiz'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='w-list'>
              <h1>
                Check Your Lucky Birthday - <span class='mark'>M11</span>
              </h1>
              <small>August, 2021</small>
              <p>
                Check Your Lucky date. Created app using
                <strong> Vanilla - JS</strong> hosted on
                <strong> Netlify.</strong>
              </p>
              <a
                class='link link-primary'
                href='https://check-lucky-birthday24x7.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/lucky-birthdate'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='ow-list'>
              <h1>
                Manager Your Cash Register - <span class='mark'>M10</span>
              </h1>
              <small>August, 2021</small>
              <p>
                Created app using <strong>Vanilla - JS</strong> hosted on
                <strong> Netlify.</strong> Know the minimum no of notes to
                return just by entering the bill amount and cash amount.
              </p>
              <a
                class='link link-primary'
                href='https://cash-register-manager24x7.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/Cash-Register-Manager'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='w-list'>
              <h1>
                Best Places Finder - <span class='mark'>M9</span>
              </h1>
              <small>April, 2021</small>
              <p>
                ReactJS app hosted on <strong>Code Sandbox</strong> to check
                best places to visit in india and outside, also check best
                places for hooneymoon.
              </p>
              <a
                class='link link-primary'
                href='https://tjn0q.csb.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/best-places-visit-app'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='ow-list'>
              <h1>
                {' '}
                Emoji Meaning Checker - <span class='mark'>M8</span>
              </h1>
              <small>April, 2021</small>
              <p>
                ReactJS app hosted on <strong>Code Sandbox</strong> to find the
                emoji meaning just by inserting the emoji or by clicking the
                emoji
              </p>
              <a
                class='link link-primary'
                href='https://nkv4t.csb.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/neogcamp-emoji-meaing-finder-app'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='w-list'>
              <h1>
                Mandalorian Talk - <span class='mark'>M7</span>
              </h1>
              <small>April, 2021</small>
              <p>
                Mando'a was the language of the people native to the planet
                Mandalore. Mandalorians also lived on the moon of Mandalore,
                Concordia, Kalevala and the planet Concord Dawn
              </p>
              <a
                class='link link-primary'
                href='https://mandalorian-talk.netlify.app/'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/mandalorian-talk'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='ow-list'>
              <h1>
                Banana Speak - <span class='mark'>M6</span>
              </h1>
              <small>April, 2021</small>
              <p>
                Are you a fan of minions? Did you know that the gibberish they
                say is an actual language. Use the translator to convert your
                text from English to Minion speak or Banana language.
              </p>
              <a
                class='link link-primary'
                href='https://banana-speak24x7.netlify.app'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/neogcamp-banana-speak'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='w-list'>
              <h1>
                <span class='mark'>M3, M4 & M5</span>
              </h1>
              <small>April, 2021</small>
              <ol>
                <li>
                  Website Hosted with Github + Netlify intergration
                  <span class='mark'> (M3)</span>
                </li>
                <li>
                  Portfolio website <span class='mark'>(M4)</span>
                </li>
                <li>
                  blog added in portfolio website <span class='mark'>(M5)</span>
                </li>
              </ol>
            </div>
          </li>

          <li>
            <div class='ow-list'>
              <h1>
                Are you Marvel fan? - <span class='mark'>M2</span>
              </h1>
              <small>April, 2021</small>
              <p>
                Now, show us just how much you know about the{' '}
                <strong>Marvel Cinematic Universe</strong> by taking this quiz.
              </p>
              <a
                class='link link-primary'
                href='https://replit.com/@way2nizam/CLI-Quiz-App?embed=1&output=1'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/neog-camp-lession-01/blob/main/neog-camp-CLI-APP-assignment'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>

          <li>
            <div class='w-list'>
              <h1>
                how well do you know me? - <span class='mark'>M1</span>
              </h1>
              <small>April, 2021</small>
              <p>
                A CLI app built with <strong>nodeJS</strong> on replit. You can
                send this to your friends and find out who really knows
              </p>
              <a
                class='link link-primary'
                href='http://replit.com/@way2nizam/neog-camp-ex-15?embed=1&output=1'
                target='_blank'
                rel='noreferrer'>
                Live Project
              </a>
              <a
                class='link link-secondary'
                href='https://github.com/way2nizam/neog-camp-lession-01/blob/main/neog-camp-ex-15-CLI-App-1'
                target='_blank'
                rel='noreferrer'>
                View Source
              </a>
            </div>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default mark15;
